import { SITE_ORIGIN, SOCIAL_SAME_AS } from './site';

// Keep this description in public/index.html as well. South Wales, not a UK-wide claim.
export const HOME_TITLE = 'The WasteGame — Find Local Waste Carriers & Removals';

export const HOME_DESCRIPTION =
  'Post a rubbish removal or house clearance job in Swansea and South Wales for free. Registered waste carriers send prices; pay by card when it is done.';

export const GOOGLE_SITE_VERIFICATION = '0hYPz6bTHOfM8LKfCQM7loVbmSIKHoOd2D7aplXcCJY';

export const HOME_PATH = '/';

export function homeJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: 'The WasteGame',
        url: SITE_ORIGIN,
        sameAs: SOCIAL_SAME_AS,
        email: 'info@thewastegame.co.uk',
        description: HOME_DESCRIPTION,
        areaServed: {
          '@type': 'AdministrativeArea',
          name: 'South Wales',
        },
      },
      {
        '@type': 'WebSite',
        name: 'The WasteGame',
        url: SITE_ORIGIN,
      },
    ],
  };
}

export const SERVICES_PAGE = {
  path: '/services',
  title: 'Services — The WasteGame',
  description:
    'Waste collection, house clearance, garden clearance and scrap collection in South Wales. Post a job free. Pay by card only after a priced job is marked complete.',
  h1: 'Our services',
};
